import axios from 'axios'
import config from '@/config'

const VueAxios = axios.create({
  baseURL: config.b_path
})

if (localStorage.getItem('token')) {
  VueAxios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
} else {
  VueAxios.defaults.headers.common['Authorization'] = ''
}
VueAxios.defaults.headers.common['Content-Type'] = 'application/json'

export default VueAxios
